import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MasterSlot, ShopMaxPerDay } from '../../shared/models/slot-management.model';
import { FeatureKeys } from '../app.reducer';
import { SalesAvailabilityState } from './sales-availability.reducer';

export const selectsalesAvailabilityFeature = createFeatureSelector<SalesAvailabilityState>(FeatureKeys.SALES_AVAILABILITY);

export const selectMasterSlots = createSelector(
    selectsalesAvailabilityFeature,
    (state: SalesAvailabilityState) => state.masterSlots.data
);

export const selectShopMaxTotal = createSelector(
    selectsalesAvailabilityFeature,
    (state: SalesAvailabilityState) => state.shopMaxTotal.data
);

export const selectShopMaxSlots = createSelector(
    selectsalesAvailabilityFeature,
    (state: SalesAvailabilityState) => state.shopMaxSlots?.data?.slotsPerDay
);

export const selectRemoteMaxTotal = createSelector(
    selectsalesAvailabilityFeature,
    (state: SalesAvailabilityState) => state.remoteMaxTotal.data
);

export const selectRemoteMaxSlots = createSelector(
    selectsalesAvailabilityFeature,
    (state: SalesAvailabilityState) => state.remoteMaxSlots?.data?.slotsPerDay
);

export const selectMaxAndMasterSlots = createSelector(
    selectShopMaxTotal,
    selectRemoteMaxTotal,
    selectMasterSlots,
    (
        shopMax: ShopMaxPerDay[], 
        remoteMax: ShopMaxPerDay[], 
        masterSlot: MasterSlot[],
        props: { view: string}
    ) => ({ max: props.view == 'Shop' ? shopMax : remoteMax , masterSlot})
);

export const selectMasterSlotsLoading = createSelector(
    selectsalesAvailabilityFeature,
    (state: SalesAvailabilityState) => state.masterSlots.loaded
);

export const selectSlotsUpdated = createSelector(
    selectsalesAvailabilityFeature,
    (state: SalesAvailabilityState) => state.shopMaxSlots.isUpdated && state.shopMaxTotal.isUpdated
);

export const selectRemoteSlotsUpdated = createSelector(
    selectsalesAvailabilityFeature,
    (state: SalesAvailabilityState) => state.remoteMaxSlots.isUpdated && state.remoteMaxTotal.isUpdated
);


